import { Text } from '@fluentui/react-components';

import type { DirectoryIdentifier } from '@/api/types';

interface IdentifierListProps {
  references?: readonly DirectoryIdentifier[];
  fallbackIds: readonly string[];
}

export function IdentifierList({ references, fallbackIds }: IdentifierListProps) {
  const identifiers = references && references.length > 0
    ? references
    : fallbackIds.map((id) => ({ id, displayName: id }));

  if (identifiers.length === 0) {
    return <>—</>;
  }

  return (
    <span>
      {identifiers.map((identifier, index) => (
        <span key={identifier.id}>
          {identifier.displayName}
          {identifier.displayName !== identifier.id && (
            <Text as="span" size={200}> ({identifier.id})</Text>
          )}
          {index < identifiers.length - 1 && ', '}
        </span>
      ))}
    </span>
  );
}
